import { CSVLink } from "react-csv";
import { millisToMinutesAndSeconds, getCurrentTimeFormatted, formatTimestamp } from "../Utils/helper.js"

export default function DownloadReportCSV({ headers, data }) {
    const csvData = data?.map((screen) => [
        screen.screen?.uid || screen.screen?.id,
        screen.screen?.name,
        millisToMinutesAndSeconds(screen.duration), 
        formatTimestamp(screen.start_time),
        screen.active === 0 ? "Failure" : "Success",
        screen.floor?.name,
        screen.building?.name,
        screen.city?.name,
        screen.state?.name,
        screen.country?.name
    ]);
    return <>
        <CSVLink
            headers={headers}
            data={csvData}
            filename={`report-${getCurrentTimeFormatted()}.csv`}
            className="btn btn-success btn-sm ml-1"
        >
            <i className="fas fa-file-download"></i> Download CSV
        </CSVLink>
    </>
}